import { configureStore } from '@reduxjs/toolkit';
import { authReducer } from './reducer/login';
import { loadingReducer } from './reducer/AppLoading';
import { historyReducer } from './reducer/history';
import { switchReducer } from './reducer/switch';
import { sessionReducer } from './reducer/session';
import instrumentReducer from './reducer/instruments';
import accountReducer from './reducer/account';
import bidaskReducer from './reducer/bidask';
import dialogReducer from './reducer/dialog';
import dropdownReducer from './reducer/dropdown';
import positionReducer from './reducer/positions';
import editDialogReducer from './reducer/edit-dialog';
import payloadReducer from './reducer/payload';
import statReducer from './reducer/stat';
import tvWidgetReducer from './reducer/tvWidget';
import orderReducer from './reducer/orders';
import accountTradeReducer from './reducer/account-trade';
import onTickReadyReducer from './reducer/checkOntick';
import tradeEventReducer from './reducer/event';
import eddReducer from './reducer/edd';
import equityReducer from './slices/equitySlice';
import positionProfitsReducer from './slices/positionProfitsSlice';

export default configureStore({
  reducer: {
    symbol: instrumentReducer,
    positions: positionReducer,
    orders: orderReducer,
    auth: authReducer,
    account: accountReducer,
    tradeDialog: dialogReducer,
    bidask: bidaskReducer,
    appLoading: loadingReducer,
    histories: historyReducer,
    tvWidget: tvWidgetReducer,
    isSwitch: switchReducer,
    editDialog: editDialogReducer,
    stat: statReducer,
    sesstion: sessionReducer,
    dropdown: dropdownReducer,
    payload: payloadReducer,
    accountTrade: accountTradeReducer,
    onTickReady: onTickReadyReducer,
    tradeEvent: tradeEventReducer,
    edd: eddReducer,
    equity: equityReducer,
    positionProfits: positionProfitsReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: {
        // Ignore these paths in the state for serialization checks
        // as they contain large arrays of trading history data
        ignoredPaths: [
          'histories.histories',
          'histories.deals',
          'histories.orders',
          'histories.positions',
          'histories.tmpPositions'
        ],
        // Optionally ignore specific action types that carry large payloads
        ignoredActions: [
          'HISTORY_TYPE_HISTORY',
          'HISTORY_TYPE_DEALLOG',
          'HISTORY_TYPE_ORDER',
          'SET_POSITIONS',
          'SET_POSITIONS_TMP',
          'SET_DEALS',
          'SET_ORDERS',
          'INIT_POSITION',
          'UPDATE_POSITION'
        ]
      }
    })
});
